var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticStyle:{"max-width":"200px","height":"100px"},attrs:{"src":_vm.themeConfig.app.appLogoImage}})}
var staticRenderFns = []

export { render, staticRenderFns }